import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getToken, setToken } from '@/utils/auth'
import { isRelogin } from '@/utils/request'

NProgress.configure({ showSpinner: false })

const whiteList = ['/my', '/bookPreview']

router.beforeEach((to, from, next) => {
  NProgress.start()
  const urlParams = new URLSearchParams(window.location.search);
  if(urlParams.get("token") && process.env.VUE_APP_SSO_LOGIN == '1') {
    store.dispatch('newLogin', urlParams.get("token"))
  }
  const token = process.env.VUE_APP_SSO_LOGIN == '1' ? (urlParams.get("token") || getToken()) : getToken();
  if (token) {
    if (to.path === '/login') {
      // 清理token参数后跳转
      next({ path: '/', query: {}, replace: true })
      NProgress.done()
    } else {
      if (store.getters.roles.length === 0) {
        isRelogin.show = true
        store
          .dispatch('GetInfo')
          .then(() => {
            isRelogin.show = false
            // 清理URL中的token参数，增强安全性
            const cleanTo = {
              path: to.path,
              query: { ...to.query }
            }
            if (cleanTo.query && cleanTo.query.token) {
              delete cleanTo.query.token
            }
            next({ ...cleanTo, replace: true })
          })
          .catch((err) => {
            console.log(err)
            store.dispatch('LogOut').then(() => {
              if(process.env.VUE_APP_SSO_LOGIN == '1') {
                window.location.href = `${process.env.VUE_APP_BASE_API}/oauth2/sso/logout?returnUrl=${location.origin}/index`;
              } else {
                next(`/index`)
              }
            })
          })
      } else {
        // 只在URL中有token时才清理，避免无限循环
        const urlToken = urlParams.get("token");
        if (urlToken) {
          // 清理token参数后跳转
          const cleanTo = {
            path: to.path,
            query: { ...to.query }
          }
          if (cleanTo.query && cleanTo.query.token) {
            delete cleanTo.query.token
          }
          // 使用history.replaceState清理URL，不触发路由守卫
          if (window.history.replaceState) {
            const url = new URL(window.location.href);
            url.searchParams.delete('token');
            window.history.replaceState({}, document.title, url.toString());
          }
          next(cleanTo)
        } else {
          // 没有token参数，正常跳转
          next()
        }
      }
    }
  } else {
    if (whiteList.indexOf(to.path) === -1) {
      next()
    } else {
      next(`/index`)
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})
